/**
 * Global loading spinner component for route transitions and suspense fallbacks.
 * Features the BitEasy logo with a heartbeat pulse animation.
 */
export function GlobalLoadingSpinner() {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-base-100/90 backdrop-blur-sm">
			<div className="relative flex flex-col items-center gap-6">
				{/* Main logo animation container */}
				<div className="relative h-24 w-24">
					{/* Outer glow ring that pulses with the logo */}
					<div
						className="absolute inset-0 rounded-full bg-linear-to-r from-primary/20 to-secondary/20 blur-xl"
						style={{ animation: "heartbeat 2s ease-in-out infinite" }}
					/>

					{/* Logo with heartbeat pulse */}
					<div
						className="relative flex h-full w-full items-center justify-center"
						style={{ animation: "heartbeat 2s ease-in-out infinite" }}
					>
						<svg
							width="64"
							height="60"
							viewBox="0 0 74 69"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							className="text-invert drop-shadow-[0_0_10px_var(--color-invert)]"
							aria-labelledby="loading-logo-title"
						>
							<title id="loading-logo-title">Loading</title>
							<rect
								width="55.5802"
								height="52.9864"
								transform="matrix(0.930359 -0.366649 0.411891 0.911233 0 20.3784)"
								fill="currentColor"
							/>
						</svg>
					</div>
				</div>

				{/* Loading text with typing effect */}
				<div className="flex items-center gap-1 text-sm font-medium text-base-content/60">
					<span>Loading</span>
					<span style={{ animation: "blink 1.4s infinite both" }}>.</span>
					<span
						style={{
							animation: "blink 1.4s infinite both",
							animationDelay: "0.2s",
						}}
					>
						.
					</span>
					<span
						style={{
							animation: "blink 1.4s infinite both",
							animationDelay: "0.4s",
						}}
					>
						.
					</span>
				</div>
			</div>

			{/* CSS Keyframe animations */}
			<style>{`
				@keyframes heartbeat {
					0%, 100% { transform: scale(1); }
					15% { transform: scale(1.15); }
					30% { transform: scale(1); }
					45% { transform: scale(1.1); }
					60% { transform: scale(1); }
				}
				
				@keyframes blink {
					0% { opacity: 0.2; }
					20% { opacity: 1; }
					100% { opacity: 0.2; }
				}
			`}</style>
		</div>
	);
}
